module.exports = __webpack_public_path__ + "img/quard6.7f15a587.png";